/* istanbul ignore file */

import formatCost from './formatCost';

export default formatCost;
